import { useEffect, useState } from 'react';
import { Input, Loader } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
import { useIsFetching } from '@tanstack/react-query';
import { GoSearch } from 'react-icons/go';
import QueryKeys from '@constants/queryKeys';
import {
  useJobDetailStore,
  useActiveCandidateFilters,
} from '@company/pages/JobOverview/DetailV2/stores/jobDetailStore';

const MIN_SEARCH_LENGTH = 3;

// Mount with key={activeTab} so switching tabs re-seeds from that tab's search.
export default function SearchInput() {
  const candidateFilters = useActiveCandidateFilters();
  const setCandidateFilters = useJobDetailStore(
    (state) => state.setCandidateFilters
  );

  const [value, setValue] = useState(candidateFilters.nameOrEmail ?? '');
  const [debounced] = useDebouncedValue(value, 400);
  const isSearching =
    useIsFetching({ queryKey: [QueryKeys.JobDetail.CANDIDATES] }) > 0;

  useEffect(() => {
    const nextSearch = debounced.length >= MIN_SEARCH_LENGTH ? debounced : '';
    if (nextSearch !== (candidateFilters.nameOrEmail ?? '')) {
      setCandidateFilters({ ...candidateFilters, nameOrEmail: nextSearch });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounced]);

  return (
    <Input
      flex={1}
      leftSection={<GoSearch size={20} />}
      placeholder="Search"
      variant="filled"
      value={value}
      onChange={(event) => setValue(event.currentTarget.value)}
      rightSection={isSearching ? <Loader size="xs" /> : null}
      rightSectionPointerEvents="none"
    />
  );
}
